import { useEffect, useState } from 'react';

// Custom hook to detect clicks outside of a specified element
const useClickOutside = (ref) => {
    const [isOutsideClicked, setIsOutsideClicked] = useState(false);

    useEffect(() => {
        // Function to handle clicks outside
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOutsideClicked(true); // Set to true when outside is clicked
            } else {
                setIsOutsideClicked(false); // Set to false if click is inside
            }
        };

        // Add event listener for mouse down (click)
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);

    return isOutsideClicked; // Return whether the click was outside
};

export default useClickOutside;
